import React from 'react'
import FuboFreeTemplate from 'src/components/template/fubofree'
import USTemplateDefault from 'src/components/template/us'
import { fanduelSportsNetworkFAQs } from 'src/constants/faqs'
import { usPlanData } from 'src/constants/planData/usPlanData'
import { useCheckFanduelRSN } from 'src/modules/hooks/useCheckFanduelRSN'
import { useFormatFanduelData } from 'src/modules/hooks/useFormatFanduelData'

export default (props) => {
  const { showFDPlanCards, rsnData } = useCheckFanduelRSN()
  const fanduelPlan = useFormatFanduelData(usPlanData.fanduel_standalone_monthly, rsnData)
  const commonProps = {
    location: props.location,
    lang: 'en',
    market: 'us',
    poster: 'https://assets-imgx.fubo.tv/marketing/lp/images/posters/fdsn_poster-1.jpg',
    title: 'Watch FanDuel Sports Network',
    subtitle: 'Stream live games and local team coverage. Regional restrictions apply.',
    networkSet: 'sports',
    customNetworks: ['fanduelsports'],
  }

  return showFDPlanCards ? (
    <FuboFreeTemplate
      {...commonProps}
      plansSharedData={{
        rsn: rsnData.rsn,
        teams: rsnData.teams,
      }}
      additionalFAQs={fanduelSportsNetworkFAQs}
      plans={[fanduelPlan, usPlanData.pro_standalone_monthly]}
      hasPlanCards={true}
    />
  ) : (
    <USTemplateDefault {...commonProps} additionalFAQs={fanduelSportsNetworkFAQs} />
  )
}
